export function Headline() {
  return (
    <div className="description__headline-block">
      <p className="description__eyebrow">
        Software Engineer &mdash;{" "}
        <span
          className="description__ex-architect"
          data-tooltip="Not the software kind. The buildings kind."
        >
          Architect
        </span>{" "}
        &mdash; Berlin
      </p>
      <h1 className="description__headline">Irina Korotkaya</h1>
    </div>
  );
}
